import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { Usuario } from '../usuario/usuario';
import { PerfilAcesso } from '../usuarios/perfis-acesso';
import { UsuariosService } from '../usuarios/usuarios.service';

@Component({
  selector: 'app-adicionar-usuarios',
  templateUrl: './adicionar-usuarios.component.html',
  styleUrls: ['./adicionar-usuarios.component.css'],
  providers: [
    UsuariosService
  ]
})
export class AdicionarUsuariosComponent implements OnInit {

	usuario: Usuario;
	perfil: PerfilAcesso;
	perfis: PerfilAcesso[];
	array_perfis_usuario = new Array();

  constructor(private usuariosService: UsuariosService, private route: ActivatedRoute, private router: Router) {
	this.usuario = new Usuario;
	this.perfil = new PerfilAcesso;

	this.usuario.nome = "teste Usuario 123";
	this.usuario.login = "usrteste";
	this.usuario.email = "teste@teste.com";
	this.usuario.cpf = "12345678911";
  }

  initForm(){
	this.usuariosService.getPerfisAcesso().then((perfil) => {
			this.perfis = perfil['dados'];
			//console.log(this.perfis);
		});
  }

	addPerfilUsuario(e) {
		if (e.target.checked) {
			//console.log(e);
			const index: number = this.array_perfis_usuario.indexOf(parseInt(e.target.value));
			if (index == -1) {
				this.array_perfis_usuario.push(parseInt(e.target.value));
			}
		} else {
			const index: number = this.array_perfis_usuario.indexOf(parseInt(e.target.value));
			if (index !== -1) {
				this.array_perfis_usuario.splice(index, 1);
			}
		}
			//console.log(this.array_perfis_usuario);
	}

	addDadosUsuario(): void{
		this.usuario.perfil_ids = this.array_perfis_usuario;
		//console.log(this.array_perfis_usuario);
		//console.log(this.usuario);
		if(this.usuariosService.addUsuario(this.usuario) !== undefined){
			this.goBack();
			//console.log('salvo!');
		}
	}

  ngOnInit() {
	  this.initForm();
  }

  goBack(): void {
		this.router.navigate(['usuarios']);
	}

}



// WEBPACK FOOTER //
// ./src/app/adicionar-usuarios/adicionar-usuarios.component.ts